var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZug(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    className: "w-full h-auto",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "_x33_0x30_37_",
    transform: "translate(0,-152.3622)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#005EA8"
    },
    d: "M25.468,153.362h49.065c13.513,0,24.468,10.564,24.468,23.596v50.808 c0,13.032-10.955,23.596-24.468,23.596H25.468C11.955,251.362,1,240.798,1,227.766v-50.808 C1,163.927,11.955,153.362,25.468,153.362z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.00644,0.99360121)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2994_3_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M32.459,218.588H8.404v-3.873L23.711,194.2H9.508v-5.477h22.91v3.769 l-14.975,20.64h15.016V218.588z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2996_3_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M60.593,205.654c0,8.969-4.179,13.454-12.538,13.454 c-8.109,0-12.163-4.381-12.163-13.142v-17.244h6.748v17.328c0,4.832,1.889,7.248,5.665,7.248c3.707,0,5.561-2.332,5.561-6.998 v-17.578h6.727L60.593,205.654L60.593,205.654z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2998_3_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M90.956,216.588c-2.916,1.68-6.54,2.52-10.872,2.52 c-4.804,0-8.591-1.33-11.361-3.989c-2.77-2.659-4.155-6.321-4.155-10.986c0-4.693,1.514-8.518,4.54-11.476 c3.027-2.958,7.054-4.436,12.079-4.436c3.166,0,5.957,0.437,8.373,1.312v6.31c-2.305-1.333-5.124-1.999-8.456-1.999 c-2.791,0-5.065,0.906-6.82,2.718c-1.757,1.812-2.635,4.232-2.635,7.258c0,3.069,0.788,5.443,2.364,7.123 c1.576,1.68,3.704,2.52,6.383,2.52c1.61,0,2.888-0.229,3.832-0.687v-5.831h-5.977v-5.374h12.704L90.956,216.588L90.956,216.588z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZug);
export default __webpack_public_path__ + "static/media/zug.11e9c2a4d80c81b18785025d611788f4.svg";
export { ForwardRef as ReactComponent };